import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { PriceRange } from 'entities/ticket/models/find-ticket/models'

import { priceShow } from 'shared/lib//priceShow'
import { RangeInput } from 'shared/ui/range-input'

import styles from './styles.module.scss'

interface Props {
  currentPrice: PriceRange | undefined
  priceRange: PriceRange | undefined
  onChange: (dataRange: number[]) => void
}

export const PriceFilter: FC<Props> = ({
  currentPrice,
  priceRange,
  onChange,
}) => {
  const { t } = useTranslation()

  const minPrice = currentPrice?.min || priceRange?.min || 0
  const maxPrice = currentPrice?.max || priceRange?.max || 0

  return (
    <div className={clsx(styles.itemBlock, styles.filterPrice)}>
      <p className={clsx(styles.title, 'bold-17')}>{t('price')}</p>

      <div className={styles.headerPrice}>
        <p className={clsx(styles.left, 'medium-14')}>{t('label_price')}</p>
        <p className={clsx(styles.right, 'medium-13')}>
          <span>
            {priceShow(String(minPrice))}{' '}
            <span className={styles.currency}>&#8384;</span>
          </span>
          {' — '}
          <span>
            {priceShow(String(maxPrice))}{' '}
            <span className={styles.currency}>&#8384;</span>
          </span>
        </p>
      </div>

      <RangeInput
        onChange={onChange}
        value={[minPrice, maxPrice]}
        {...priceRange}
      />
    </div>
  )
}
